// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zw-0";
export var tagInputDisabled = "_zw-1";